import { render, staticRenderFns } from "./_editorDrug.vue?vue&type=template&id=56c7c890"
import script from "./_editorDrug.vue?vue&type=script&lang=js"
export * from "./_editorDrug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports